import { Route, Routes } from "react-router-dom";
import { AppRoute, useGetRoutesArray } from "./routes";

const mapRoute = (r: AppRoute) => {
  return <Route key={r.path} path={r.path} element={<>{r.element}</>} />;
};

export const AppRoutes = () => {
  const routes = useGetRoutesArray();
  return <Routes>{routes.map(mapRoute)}</Routes>;
};
